import { useMutation } from "@tanstack/react-query";
import { GetFilesRequest } from "../models";
import { FilesService } from "../FilesService";

export const useFiles = () => {
  const {
    isPending,
    mutateAsync: getFiles,
    data,
    error,
  } = useMutation({
    mutationFn: async (params: GetFilesRequest) => {
      const response = await FilesService.getFiles(params);
      return response?.data?.files;
    },
  });

  return { isPending, getFiles, clientFiles: data || [], error };
};
